import { render, staticRenderFns } from "./AdminSoepIndexCard.vue?vue&type=template&id=befc4b0c&"
import script from "./AdminSoepIndexCard.vue?vue&type=script&lang=js&"
export * from "./AdminSoepIndexCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports